/** Decimal hours as h:mm, the way timesheets show durations. */
export const formatHours = (hours: number) => {
  const minutes = Math.round(hours * 60)
  return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`
}

export const perWeek = (totalHours: number, weeks: number) =>
  weeks ? totalHours / weeks : 0
